// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    DispatchCompleteRemoveCartLine,
    RemoveCartLine,
    chain as RemoveCartLineChain,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { xGoogleAnalyticsState } from "@tps/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@tps/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { formatCategories } from "@tps/App/GoogleAnalyticsConnector/Utilities/formatCategories";

export const _GaRemoveCartLine: typeof DispatchCompleteRemoveCartLine = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.removeFromCartLineEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const cart = getCurrentCartState(props.getState()).value;
        const cartLine = cart?.cartLines?.find(c => c.id === props.apiParameter.cartLineId);
        const session = getSession(state);

        if (!cartLine) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.removeFromCartLineEventName,
            currency: session.currency?.currencyCode,
            value: cart?.orderGrandTotal,
            cart_value: cart?.orderGrandTotal,
            customer_number: state.xGoogleAnalytics.customerNumber,
            user: session?.userProfileId,
            company_name: state.xGoogleAnalytics.affiliation,
            customer_id: session?.billToId,
            items: [
                {
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    coupon: cart?.promotionCode || "",
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    index: cartLine.line,
                    discount: cartLine.pricing
                        ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                            ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                            : 0
                        : 0,
                    item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
                    ...(state.xGoogleAnalytics["includeProductCategory"]
                        ? formatCategories(cartLine?.properties?.categoryTree)
                        : {}),
                    item_list_id: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["categoryId"] || ""
                        : undefined,
                    item_variant: cartLine?.properties?.["varientValue"] || "",
                    location_id: session.pickUpWarehouse?.id,
                    item_list_name: "",
                    affiliation: state.xGoogleAnalytics.affiliation,
                },
            ],
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(RemoveCartLineChain, RemoveCartLine, _GaRemoveCartLine);
